"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getReportAConcernPageData = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
/* istanbul ignore file */ const getReportAConcernPageData = async (param)=>{
    let { language, staticApiUrl, tenant } = param;
    const client = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        language,
        tenant
    });
    const [{ data: formConfig }, { data: formData }] = await Promise.all([
        (0, _staticApiClientReact.getTenantApplicationsConcernReportFormConfiguration)(client, tenant, {
            lang: language
        }),
        (0, _staticApiClientReact.getTenantApplicationsConcernReportFormLocalization)(client, tenant, {
            lang: language
        })
    ]);
    return {
        formConfig,
        formData
    };
};
exports.getReportAConcernPageData = getReportAConcernPageData;
